import Rest from '@/services/Rest';

/**
 * @typedef {ContractService}
 */
export default class ContractService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/contract'

  blob(params) {
    return this.post('/export', params, { responseType: 'blob' });
  }

  chargeAttempts(contractId, currentCharge) {
    return this.get(`/${contractId}/charges/${currentCharge}/attempts`);
  }

  /**
   * Regera boleto de uma venda do contrato (Laravel).
   * @param {number|string} saleId
   * @param {number} dueDays
   */
  retryBoleto(saleId, dueDays = 3) {
    return this.post(
      `/retry-boleto/sale/${saleId}`,
      { due_days: dueDays },
      { suppressErrorNotify: true }
    );
  }
}
